const searchIncorporators = async (inputQuery) => {
    if (inputQuery.length >= 2) {
        const { data } = await axios.get("/incorporadoras-json?incorporadora=" + inputQuery);

        return data;
    }
    return [];
};

const searchCity = async (inputQuery) => {
    if (inputQuery.length >= 2) {
        const { data } = await axios.get("/cidades/json-options/" + inputQuery);
        return data;
    }
    return [];
};


export { searchIncorporators, searchCity}